<template>
	<div>This is Dw</div>
</template>
<script type="text/javascript">
	export default {
		name:'Dw'
	}
</script>


// WEBPACK FOOTER //
// src/Dw/containers/Dw.vue